import { HTTPClient } from "./Client";

const TurmaApi = {

    async listarStatusTurmasAsync() {
        const response = await HTTPClient.get(`/Turma/ListarStatusTurma`);
        return response.data;
    },

    async listarPeriodoTurmasAsync() {
        const response = await HTTPClient.get(`/Turma/ListarPeriodosTurma`);
        return response.data;
    },

    async listarModalidadeTurmasAsync() {
        const response = await HTTPClient.get(`/Turma/ListarModalidadesTurma`);
        return response.data;
    },

    async adicionarTurmaAsync(nome, descricao, periodo, modalidade) {
        const novaTurma = {
            Nome: nome,
            Descricao: descricao,
            Periodo: Number(periodo),
            Modalidade: Number(modalidade)
        };

        await HTTPClient.post(`/Turma/AdicionarTurma`, novaTurma);
    },

    async deletarTurmaAsync(turmaId) {
        await HTTPClient.put(`/Turma/DeletarTurma/${turmaId}`);
    },

    async listarTurmasAsync(pagina, nome, periodo) {
        const turmasComPaginacao = {
            Pagina: pagina,
            Nome: nome,
            Periodo: Number(periodo)
        };

        const response = await HTTPClient.post(`/Turma/ListarTurmas`, turmasComPaginacao);
        return response.data;
    },

    async ListarTurmaSemPaginacaoAsync() {
        const response = await HTTPClient.get(`/Turma/ListarTurmasSemPaginacao`);
        return response.data;
    },
    async ListarTurmasComAlunosCoordenador() {
        const response = await HTTPClient.get(`/Turma/ListarTurmasComAlunosCoordenador`);
        return response.data;
    },


    async editarTurmaAsync(turmaId, nome, descricao, periodo, modalidade, status) {
        const turma = {
            Id: turmaId,
            Nome: nome,
            Descricao: descricao,
            Periodo: Number(periodo),
            Modalidade: Number(modalidade),
            Status: Number(status)
        }

        const response = await HTTPClient.put(`/Turma/AtualizarTurma`, turma);
        return response.data;
    },

    async obterPessoasDaTurmaAsync(turmaId) {

        const response = await HTTPClient.get(`/Turma/ObterPessoasDaTurma/${turmaId}`);
        return response.data;
    },

    async obterDadosDaTurmaAsync(turmaId) {

        const response = await HTTPClient.get(`/Turma/ObterTurmaPorId/${turmaId}`);
        return response.data;
    },

    async criarTurmaComMoodleAsync(nome, descricao, periodo, modalidade, courseId) {
        const novaTurma = {
            NomeTurma: nome,
            Descricao: descricao,
            Periodo: Number(periodo),
            Modalidade: Number(modalidade),
            CourseId: Number(courseId)
        };

        await HTTPClient.post(`/Turma/criar-com-moodle`, novaTurma);
    },

    async editarTurmaComMoodleAsync(turmaId, nome, descricao, periodo, modalidade, status) {

        const turma = {
            NomeTurma: nome,
            Descricao: descricao,
            Periodo: Number(periodo),
            Modalidade: Number(modalidade),
            Status: Number(status)
        }

        const response = await HTTPClient.put(`/Turma/${turmaId}/editar-com-moodle`, turma);

        return response.data;
    }
}

export default TurmaApi;